<template>
	<Col>
		<Row class="title-text">Current draft version</Row>
		<template v-if="doesWorkflowNeedPublish">
			<WorkflowVersionIndication class="mb-2" :versionNumber="draftVersionNumber" />
			<h5 class="description-text">Last edited {{ lastEditedByTimeAgo }}</h5>
			<Row v-if="isLoading" class="flex-centerize with-100 mb-n3 mt-3">
				<AppLoader />
			</Row>
			<template v-else>
				<MaybeUpgradeRequiredIndicator :billingFeatureId="billingFeatureId">
					<template #default="{ indicator, isUpgradeRequired }">
						<Row>
							<h5 @click="$emit('save-version')" class="version-link" :class="{ 'disabled-linked': isUpgradeRequired }">
								Save draft and create new version
							</h5>
							<div class="pl-2" v-if="isUpgradeRequired">
								<component :is="indicator" :billingFeatureId="billingFeatureId" />
							</div>
						</Row>
					</template>
				</MaybeUpgradeRequiredIndicator>
			</template>
		</template>
		<h5 v-else class="description-text">No draft present. A new draft will be created when you make a change.</h5>
	</Col>
</template>

<script>
import moment from 'moment';

import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { FeatureTypes } from '@/components/Billing/billing-types';
import WorkflowVersionIndication from '@/components/WorkflowVersionHistory/WorkflowVersionIndication.vue';
import WorkflowVersionService from '@/components/WorkflowVersionHistory/workflow-version-service';
export default {
	name: 'WorkflowVersionHistoryMenuDraftVersion',
	components: { WorkflowVersionIndication, MaybeUpgradeRequiredIndicator },
	props: {
		isLoading: { type: Boolean },
		workflowCurrentVersion: { type: Object },
		workflow: { type: Object, required: true },
		workflowCurrentDraft: { type: Object, required: true },
	},
	computed: {
		currentDraftVersionText() {
			return `Version ${this.draftVersionNumber}`;
		},
		draftVersionNumber() {
			return WorkflowVersionService.getWorkflowDraftVersionNumber(this.workflow);
		},
		doesWorkflowNeedPublish() {
			return this.workflow.draft_pending_changes_flag || !this.hasWorkflowEverBeenPublished;
		},
		hasWorkflowEverBeenPublished() {
			return this.workflow.is_published;
		},
		lastEditedByTimeAgo() {
			return moment(this.workflowCurrentDraft.updated_at).fromNow();
		},
		billingFeatureId() {
			return FeatureTypes.VersionHistory;
		},
	},
};
</script>

<style scoped lang="scss">
@import '@/components/WorkflowVersionHistory/workflow-version-history-menu.scss';
</style>
